/* eslint-disable no-console */

// La app dejó de funcionar como PWA (el prompt de "instalar aplicación"
// confundía a los usuarios y el service worker generado por
// @vue/cli-plugin-pwa quedaba "waiting" indefinidamente, sirviendo
// versiones viejas cacheadas). Esto desregistra cualquier service worker
// que haya quedado activo en dispositivos donde la app ya se había
// instalado/cacheado, para que vuelvan a pedir todo directo del servidor.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations().then((registrations) => {
    registrations.forEach((registration) => {
      registration.unregister().catch(() => {})
    })
  }).catch(() => {})
}

if (window.caches) {
  caches.keys().then((keys) => {
    keys.forEach((key) => caches.delete(key))
  }).catch(() => {})
}
